import { Table, TableBody, TableHead, TableRow, IconButton } from '@mui/material';
import {
  ActionIconButton,
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
} from '../../../common/components';

import VpnKeyIcon from '@mui/icons-material/VpnKey';

const ProfilesDataTable = ({
  data,
  isLoading,
  onEdit,
  onDelete,
  onAccessEdit,
  LoadingComponent,
}) => {
  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <GeneralTableBox>
      <Table aria-label="profiles table">
        <TableHead>
          <TableRow>
            <HeadTableCell sx={{ width: '15%' }}>Nombre</HeadTableCell>
            <HeadTableCell sx={{ textAlign: 'center', width: '18%' }}>Acciones</HeadTableCell>
            <HeadTableCell sx={{ textAlign: 'center', width: '12%' }}>Accesos</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((profile) => (
            <TableRow key={profile.uuid}>
              <RowTableCell>{profile.name}</RowTableCell>
              <RowTableCell sx={{ textAlign: 'center' }}>
                <ActionIconButton variant="edit" onClick={() => onEdit(profile)} />
                <ActionIconButton variant="delete" onClick={() => onDelete(profile.uuid)} />
              </RowTableCell>
              <RowTableCell sx={{ textAlign: 'center' }}>
                <IconButton onClick={() => onAccessEdit(profile)} size="small">
                  <VpnKeyIcon sx={{ color: 'red' }} />
                </IconButton>
              </RowTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default ProfilesDataTable;
